var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.0001 0.884766C5.37268 0.884766 0 6.05511 0 12.4329C0 18.1531 4.32626 22.8903 9.9987 23.8076V14.8422H7.10393V11.6159H9.9987V9.23692C9.9987 6.47665 11.7506 4.97247 14.3096 4.97247C15.5353 4.97247 16.5886 5.06036 16.8944 5.09907V7.98428L15.1194 7.98511C13.728 7.98511 13.4598 8.62128 13.4598 9.55514V11.6142H16.7798L16.3468 14.8405H13.4598V23.8848C19.397 23.1894 24 18.3314 24 12.4296C24 6.05511 18.6273 0.884766 12.0001 0.884766Z","fill":"#D71C2E"}));
}

FacebookIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
